<template>
  <el-dialog :title="$t('fba.pay')" :visible.sync="visible" width="50%" custom-class="pay-dialog" @close="handleClose">
    <div class="content">
      <div class="pay-method pay-flex">
        <div class="label"><span style="color: #F56C6C; margin-right: 4px;">*</span>{{ $t('recharge.chooseRechargeMethod') }}</div>
        <div class="value">
          <el-button size="small" class="recharge-btn" :class="{ lxBtnBlueDeep: payMethod === 2 }"
            @click="changeMethod(2)">
            {{  $t('fund.bankPay') }}
          </el-button>
          <el-button v-if="hasPaypal" size="small" class="recharge-btn" :class="{ lxBtnBlueDeep: payMethod === 1 }"
            @click="changeMethod(1)">
            PayPal
          </el-button>
          <el-button size="small" class="recharge-btn" :class="{ lxBtnBlueDeep: payMethod === 0 }"
            @click="changeMethod(0)">
            {{ $t("createOrder.createOrder7") }}
          </el-button>
        </div>
      </div>
      <div class="pay-content pay-flex">
        <div class="balance">
          <div>
            <span>{{ $t('fund.balance') }}：</span>
            <span class="mount">{{ addThousandSeparator(info.canUseBalance) }}</span>
          </div>
          <el-switch
            v-if="payMethod !== 0"
            style="margin-left: 10px;"
            v-model="switchValue"
            size="large"
            :active-text="$t('fund.useBalance')"
            @change="switchChange"
            active-color="#f27406"
          />
          <el-input-number
            v-if="payMethod !== 0 && switchValue"
            size="small"
            :controls="false"
            v-model="balanceMoney"
            :min="0"
            :max="info.canUseBalance > data.rechargeDto.money ? data.rechargeDto.money : info.canUseBalance"
          />
        </div>
        <div class="amount">
          <div class="label">
          {{ payMethod === 1 ? `paypal${$t('OrderBill.OrderBill7')}` : $t('OrderBill.OrderBill7') }}
          </div>
          <div class="value">
            <span class="cny">{{ addThousandSeparator(data.rechargeDto.money.toFixed(2)) }}<i>元</i></span>
            <span class="jpy">{{ addThousandSeparator(jpyAmount) }}<i>円</i></span>
          </div>
        </div>
      </div>
      <div class="pay-fee-text" v-show="payMethod === 1">{{ $t('recharge.zcl40add8') }} {{payDetail?.paypalRate}}% + {{ payDetail?.paypalFee }} 円</div>
      <div v-show="showPaypalBtn" style="margin-top: 10px;">
        <PaypalButton v-if="payMethod === 1" :amount="amount" :paypalObj="paypalObj" currency="USD"
          @getPayDetail="getPayDetail" @success="handleConfirm" />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" class="recharge-btn" @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button :disabled="confirmDisabled" size="small" type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PaypalButton from '@/components/PaypalButton/index.vue'

export default {
  components: { PaypalButton },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      payMethod: 2,
      payDetail: {},
      amount: 0,
      switchValue: false,
      info: {},
      balanceMoney: 0,
      jpyAmount: 0,
      bankId: null,
      bankInfo: {},
      bankList: [],
      hasPaypal: false,
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initPayDialog();
        }
      }
    },
    balanceMoney() {
      const { paypalRate, paypalFee } = this.payDetail;
      const { money } = this.cnyMoney;
      this.amount = Math.ceil(
        (
          money +
          money * (paypalRate/100)
        ) * this.exchangeRate + paypalFee
      )
    }
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit('update:dialogVisible', val);
      }
    },
    payMoney() {
      const { money } = this.cnyMoney;

      if (this.payMethod === 2 && this.switchValue) {
        return Math.ceil(money * this.exchangeRate)
      }

      return this.jpyAmount;
    },
    confirmDisabled() {
      const { total } = this.cnyMoney;
      const balance = this.info.canUseBalance;
      const isCanPay = balance - total >= 0;
      if (this.payMethod === 0 && !isCanPay) {
        return true;
      }

      return false;
    },
    payType() {
      let type = ''
      const { total } = this.cnyMoney
      // 支付方式不是余额,但是余额支付比例高于付款总金额,也就是相当于余额支付了
      const balancePay = this.payMethod !== 0 && this.switchValue && this.balanceMoney > total;
      if (balancePay) {
        return type;
      }
      // 组合支付打开并且填写的余额大于0时
      if (this.switchValue && this.balanceMoney > 0) {
        this.payMethod === 1 ? type = '5' : type = '7'
      } else {
        this.payMethod === 1 ? type = '4' : type = '6'
      }
      
      return type
    },
    paypalObj() {
      const { rechargeDto } = this.data
      const { money: payMoney } = this.cnyMoney;
      return {
        ...this.data,
        payType: this.payType,
        balanceAmount: this.balanceMoney,
        thirdPayAmount: payMoney,
        rechargeDto: {
          exchangeRate: this.exchangeRate,
          money: payMoney,
          moneyJpy: Math.ceil(payMoney * this.exchangeRate),
          rechargeType: rechargeDto.rechargeType,
        }
      }
    },
    showPaypalBtn() {
      return this.payMethod === 1 && this.balanceMoney < this.data.rechargeDto.money
    },
    cnyMoney() {
      const total = Number(this.data?.rechargeDto?.money || 0);
      const balance = Number(this.balanceMoney || 0);
      return {
        total,
        balance,
        money: Number((total - balance).toFixed(2))
      }
    }
  },
  methods: {
    initPayDialog() {
      this.queryJpyExchangeRate();
      this.getPaypalConfig();
      this.getUserInfo();
      this.fetchBasicInfoConfig();
    },
    syncAmount() {
      const { total } = this.cnyMoney
      this.jpyAmount = Math.ceil(total * this.exchangeRate);
      if (this.switchValue) {
        const canUseBalance = Number(this.info.canUseBalance || 0);
        this.balanceMoney = total > canUseBalance ? canUseBalance : total;
      }
    },
    handleClose() {
      this.payMethod = 2;
      this.payDetail = {};
      this.amount = 0;
    },
    handleConfirm() {
      const { money } = this.cnyMoney;
      let payMethod = this.payMethod;
      if (!money && this.switchValue) {
        payMethod = 0
      }
      this.$emit('submit', payMethod, {
        payMoney: this.payMoney, 
        payType: this.payType,
        balanceMoney: this.balanceMoney,
        money: this.cnyMoney.money
      });
      this.visible = false;
    },
    changeMethod(val) {
      this.payMethod = val
      this.syncAmount();
    },
    getPayDetail(data) {
      const { paypalFee, paypalRate } = data;
      this.payDetail.paypalFee = paypalFee;
      this.payDetail.paypalRate = paypalRate;
      const { money, total } = this.cnyMoney
      this.amount = Math.ceil(
        (
          money +
          money * (paypalRate/100)
        ) * this.exchangeRate + paypalFee
      )
      this.jpyAmount = Math.ceil(
        (
          total +
          total * (paypalRate/100)
        ) * this.exchangeRate + paypalFee
      )
    },
    addThousandSeparator(num) {
			return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
    async getUserInfo() {
      this.syncAmount();
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      this.info = res.data;
    },
    async getPaypalConfig() {
      const { data: res } = await this.$http.get('paypal/config');
      this.hasPaypal = res.data ? true : false
    },
    switchChange(val) {
      if (val) {
        this.balanceMoney = this.data.rechargeDto.money > this.info.canUseBalance ? this.info.canUseBalance : this.data.rechargeDto.money
      } else {
        this.balanceMoney = 0
      }
    },
    async fetchBasicInfoConfig() {
      try {
        const { data: res } = await this.$http.get('basicInfoConfig', { headers: { noLoading: true } });
        if (res.code == 0) {
          this.bankList = res.data.bankAccountList || [];
          this.bankId = 0;
          this.handleChangeBank();
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleChangeBank() {
      let index = this.bankId;
      this.bankInfo = this.bankList[index];
    },
    async queryJpyExchangeRate() {
      await this.$http.get("exchangeRate/queryJPYExchangeRate", {}).then((res) => {
        this.exchangeRate = res.data.data.exchangeRate || 0;
        this.syncAmount();
      });
    },
  }
};
</script>

<style scoped lang="less">
/deep/ .pay-dialog {
  max-width: 670px;
  .el-button.recharge-btn {
    border-color: #1f6feb;
    color: #1f6feb;
  }
}
.pay-flex {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.pay-fee-text {
  text-align: right;
  color: #f27406;
  font-size: 14px;
}
.value {
  i {
    font-style: normal;
    font-size: 12px;
  }
}
.pay-method {
  .label {
    margin-bottom: 10px;
  }
}
.pay-content {
  margin-top: 10px;
  gap: 8px;
}
.cny, .jpy {
  font-size: 24px;
}
.jpy {
  margin-left: 10px;
  color: #f27406;
}
.balance {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}
.mount {
  color: #f27406;
}
/deep/.el-switch__label.is-active {
  color: #f27406;
}
</style>
